import { connect } from 'react-redux';
import { push as historyPush } from 'react-router-redux';
import { addError } from 'common/src/app/actions/errorActions';
import ImplicitRedirectCallback from './ImplicitRedirectCallback';

export default connect(null, {
  historyPush,
  addError,
})(ImplicitRedirectCallback);
